// extracted by mini-css-extract-plugin
module.exports = {"blinkingCursor":"Prompt-style--blinkingCursor--22XeD","blink":"Prompt-style--blink--1O6Pr"};